/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonneGridDto
 */
export interface PersonneGridDto {
    /**
     * 
     * @type {number}
     * @memberof PersonneGridDto
     */
    idpersonne?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonneGridDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonneGridDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonneGridDto
     */
    prenom2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonneGridDto
     */
    codesexe?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonneGridDto
     */
    nationalite?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonneGridDto
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PersonneGridDto
     */
    registreNational?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonneGridDto
     */
    dateDeces?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof PersonneGridDto
     */
    isApprenant?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonneGridDto
     */
    isFormateur?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonneGridDto
     */
    isRepresentant?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonneGridDto
     */
    isUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonneGridDto
     */
    isChefEntreprise?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonneGridDto
     */
    isTuteur?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonneGridDto
     */
    isDelegueTutelle?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonneGridDto
     */
    isConseillePedagogique?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonneGridDto
     */
    isContact?: boolean;
}

/**
 * Check if a given object implements the PersonneGridDto interface.
 */
export function instanceOfPersonneGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PersonneGridDtoFromJSON(json: any): PersonneGridDto {
    return PersonneGridDtoFromJSONTyped(json, false);
}

export function PersonneGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonneGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'prenom2': !exists(json, 'prenom2') ? undefined : json['prenom2'],
        'codesexe': !exists(json, 'codesexe') ? undefined : json['codesexe'],
        'nationalite': !exists(json, 'nationalite') ? undefined : json['nationalite'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'registreNational': !exists(json, 'registreNational') ? undefined : json['registreNational'],
        'dateDeces': !exists(json, 'dateDeces') ? undefined : (json['dateDeces'] === null ? null : new Date(json['dateDeces'])),
        'isApprenant': !exists(json, 'isApprenant') ? undefined : json['isApprenant'],
        'isFormateur': !exists(json, 'isFormateur') ? undefined : json['isFormateur'],
        'isRepresentant': !exists(json, 'isRepresentant') ? undefined : json['isRepresentant'],
        'isUser': !exists(json, 'isUser') ? undefined : json['isUser'],
        'isChefEntreprise': !exists(json, 'isChefEntreprise') ? undefined : json['isChefEntreprise'],
        'isTuteur': !exists(json, 'isTuteur') ? undefined : json['isTuteur'],
        'isDelegueTutelle': !exists(json, 'isDelegueTutelle') ? undefined : json['isDelegueTutelle'],
        'isConseillePedagogique': !exists(json, 'isConseillePedagogique') ? undefined : json['isConseillePedagogique'],
        'isContact': !exists(json, 'isContact') ? undefined : json['isContact'],
    };
}

export function PersonneGridDtoToJSON(value?: PersonneGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idpersonne': value.idpersonne,
        'nom': value.nom,
        'prenom': value.prenom,
        'prenom2': value.prenom2,
        'codesexe': value.codesexe,
        'nationalite': value.nationalite,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'registreNational': value.registreNational,
        'dateDeces': value.dateDeces === undefined ? undefined : (value.dateDeces === null ? null : value.dateDeces.toISOString()),
        'isApprenant': value.isApprenant,
        'isFormateur': value.isFormateur,
        'isRepresentant': value.isRepresentant,
        'isUser': value.isUser,
        'isChefEntreprise': value.isChefEntreprise,
        'isTuteur': value.isTuteur,
        'isDelegueTutelle': value.isDelegueTutelle,
        'isConseillePedagogique': value.isConseillePedagogique,
        'isContact': value.isContact,
    };
}

